import { VendorView } from '@trackly/shared';

// ── Factory ────────────────────────────────────────────────────────

export function createDefaultVendor(): VendorView {
  const currentDateTime = new Date().toISOString();

  return {
    id: '',
    vendorNumber: '',
    companyName: '',
    dba: '',
    status: 'ACTV',
    statusName: 'Active',
    createdDate: currentDateTime,
    modifiedDate: currentDateTime,
    primaryContactName: '',
    primaryPhone: '',
    primaryEmail: '',
    secondaryContactName: '',
    secondaryPhone: '',
    secondaryEmail: '',
    website: '',
    street: '',
    city: '',
    state: '',
    zip: '',
  };
}
